
class Cart extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('[name="updates[]"]').forEach(input =>
      input.addEventListener('change', () =>
        this.change(input.dataset.lineItemKey, Number(input.value))
      )
    )

    this.querySelectorAll('.btn-line-item-remove').forEach(btn =>
      btn.addEventListener('click', () =>
        this.change(btn.dataset.lineItemKey, 0)
      )
    )

    this.querySelectorAll('.select-line-item-change').forEach(select =>
      select.addEventListener('change', () => {
        const lineItemKey = select.dataset.lineItemKey
        const newVariantId = Number(select.value)
        const qty = Number(select.dataset.qty)
        this.changeVariant(lineItemKey, newVariantId, qty)
      })
    )

    this.showOffcanvasIfUrl()
    this.adjustCollapses()
  }

  async add (formData) {
    let response

    if (formData instanceof FormData) {
      formData.append('sections', ['cart-count-badge', 'offcanvas-cart'])
      formData.append('sections_url', window.location.pathname)

      response = await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
        method: 'POST',
        body: formData
      })
    } else {
      formData.sections = ['cart-count-badge', 'offcanvas-cart']
      formData.sections_url = window.location.pathname

      response = await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
    }

    console.log(response)
    const data = await response.json()
    console.log(data)

    if (response.ok) {
      window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: data }))
      this.reloadCartElements(data.sections)
    } else {
      this.showError(data.description)
    }

    document.querySelectorAll('.offcanvas').forEach(offcanvas => {
      if (offcanvas.id === 'offcanvas-cart') {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).show()
      } else {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).hide()
      }
    })
  }

  async change (id, quantity) {
    this.classList.add('loading')

    const response = await fetch(`${window.Shopify.routes.cart_change_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id,
        quantity,
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      })
    })
    console.log(response)
    const data = await response.json()
    console.log(data)

    if (response.ok) {
      window.dispatchEvent(new CustomEvent('kt.cart.changed', { detail: data }))
      this.reloadCartElements(data.sections)
    } else {
      this.showError(data.description)
    }

    this.classList.remove('loading')
  }

  async changeVariant (lineItemKey, newVariantId, quantity) {
    this.classList.add('loading')

    const changeResponse = await fetch(`${window.Shopify.routes.cart_change_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: 0,
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      })
    })
    console.log(changeResponse)
    const changeData = await changeResponse.json()
    console.log(changeData)

    if (changeResponse.ok) {
      window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: changeData }))
    } else {
      this.showError(changeData.description)
    }

    const addResponse = await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: newVariantId, quantity }],
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      })
    })
    console.log(addResponse)
    const addData = await addResponse.json()
    console.log(addData)

    if (addResponse.ok) {
      window.dispatchEvent(new CustomEvent('kt.cart.changed', { detail: addData }))
      this.reloadCartElements(addData.sections)
    } else {
      this.showError(addData.description)
    }

    this.classList.remove('loading')
  }

  reloadCartElements (sections) {
    for (const [key, value] of Object.entries(sections)) {
      const newDoc = new DOMParser().parseFromString(value, 'text/html')

      switch (key) {
        case 'cart-count-badge':
          document.querySelectorAll('.cart-count-badge').forEach(elem => {
            const newDoc = new DOMParser().parseFromString(value, 'text/html')
            elem.replaceWith(newDoc.querySelector('.cart-count-badge'))
          })
          break
        case 'offcanvas-cart':
          document.querySelectorAll('.cart-container').forEach(elem => {
            elem.replaceWith(newDoc.querySelector('cart-container'))
          })
          break
      }
    }

    window.dispatchEvent(new CustomEvent('kt.cart.reloaded'))
  }

  showError (message) {
    const alert = this.querySelector('.alert')

    if (alert) {
      alert.querySelector('[data-alert-msg]').innerHTML = message
      alert.removeAttribute('hidden')
    }
  }

  showOffcanvasIfUrl () {
    if (new URLSearchParams(window.location.search).has('cart')) {
      const offcanvas = document.querySelector('#offcanvas-cart')

      if (offcanvas) {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).show()
      }
    }
  }

  adjustCollapses () {
    this.querySelectorAll('.collapse-wrapper [data-bs-toggle="collapse"]').forEach(elem => {
      elem.addEventListener('click', () => {
        setTimeout(() => {
          const offcanvasBody = this.querySelector('.offcanvas-body')
          offcanvasBody.scroll({ top: offcanvasBody.scrollHeight, behavior: 'smooth' })
        }, 250)
      })
    })
  }
}
customElements.define('cart-container', Cart)

class CartUpsells extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('select[name="id"').forEach(select => {
      select.addEventListener('change', () => this.onChangeVariant(select))
    })
  }

  onChangeVariant (select) {
    const variantImage = select[select.selectedIndex].dataset.variantImage

    if (variantImage.length) {
      select.closest('.cart-upsells-item').querySelector('.img-wrapper img').setAttribute('src', variantImage)
    }
  }
}
customElements.define('cart-upsells', CartUpsells)

class CartGoal extends HTMLElement {
  constructor () {
    super()

    this.progressBar = this.querySelector('.progress-bar')
    this.animateProgressBar()
    this.initTooltips()
    this.initConfetti()
  }

  animateProgressBar () {
    setTimeout(() => {
      this.progressBar.style.width = this.progressBar.dataset.width
    }, 250)
  }

  initTooltips () {
    this.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) =>
      window.bootstrap.Tooltip.getOrCreateInstance(el))
  }

  async initConfetti () {
    if (this.dataset.showConfetti === 'false') return

    const goalCompleted = Number(this.dataset.goalCompleted)
    const prevGoalCompleted = Number(localStorage.getItem('ks-cart-goal-completed') || 0)

    if (prevGoalCompleted !== goalCompleted) {
      localStorage.setItem('ks-cart-goal-completed', goalCompleted)
    }

    if (goalCompleted <= prevGoalCompleted) return

    const myCanvas = document.createElement('canvas')
    myCanvas.setAttribute('id', 'cart-goal-confetti-canvas')
    document.querySelector('#offcanvas-cart .offcanvas-body').insertAdjacentElement('afterbegin', myCanvas)

    const myConfetti = window.confetti.create(myCanvas)

    myConfetti({
      particleCount: 400,
      spread: 90
    })

    setTimeout(() => {
      myCanvas.remove()
    }, 4000)
  }
}
customElements.define('cart-goal', CartGoal)

class CartNote extends HTMLElement {
  constructor () {
    super()

    this.input = this.querySelector('textarea')
    this.btn = this.querySelector('button')
    this.btn.addEventListener('click', this.onSubmit.bind(this))
  }

  async onSubmit () {
    this.btn.classList.add('loading')

    await fetch(`${window.Shopify.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: this.input.value })
    })

    this.btn.innerHTML = `✓ <span class="visually-hidden">${this.btn.dataset.textNoteSaved}</span>`

    setTimeout(() => {
      this.btn.innerHTML = this.btn.dataset.textBtnSave
    }, 3000)

    this.btn.classList.remove('loading')
  }
}
customElements.define('cart-note', CartNote)

class CartDiscount extends HTMLElement {
  constructor () {
    super()

    this.input = this.querySelector('input')
    this.btn = this.querySelector('button')
    this.btn.addEventListener('click', this.onSubmit.bind(this))
  }

  async onSubmit () {
    this.btn.style.width = this.btn.clientWidth + 2 + 'px'
    this.btn.classList.add('loading')

    await fetch(`${window.Shopify.routes.root_url}discount/${this.input.value}`)
    window.location.href = '/checkout'

    setTimeout(() => {
      this.btn.classList.remove('loading')
    }, 2000)
  }
}
customElements.define('cart-discount', CartDiscount)

class CartShippingCalculator extends HTMLElement {
  constructor () {
    super()

    this.country = this.querySelector('#shipping-calculator-country')
    this.province = this.querySelector('#shipping-calculator-province')
    this.zip = this.querySelector('#shipping-calculator-zip')
    this.alert = this.querySelector('#shipping-calculator-alert')

    this.btn = this.querySelector('button')
    this.btn.addEventListener('click', this.onSubmit.bind(this))

    this.init()
  }

  async init () {
    const script = document.createElement('script')
    script.src = this.dataset.shopifyCommonJs
    document.head.appendChild(script)

    await new Promise(resolve => setTimeout(resolve, 1000))

    // eslint-disable-next-line no-new
    new window.Shopify.CountryProvinceSelector('shipping-calculator-country', 'shipping-calculator-province', {
      hideElement: 'shipping-calculator-province-wrapper'
    })
  }

  async onSubmit () {
    this.btn.classList.add('loading')

    const firstRes = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.country.value}&shipping_address[province]=${this.province.value}`, {
      method: 'POST'
    })
    console.log(firstRes)

    if (firstRes.ok) {
      const secondRes = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.country.value}&shipping_address[province]=${this.province.value}`)
      console.log(secondRes)

      const data = await secondRes.json()
      console.log(data)

      let list = ''

      if (data.shipping_rates.length) {
        data.shipping_rates.forEach(elem => {
          list += `
            <li>
              <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
            </li>
          `
        })

        this.alert.innerHTML = `
          <ul class="ps-5 mb-0">
            ${list}
          </ul>
        `
        this.alert.classList.remove('alert-danger', 'alert-warning')
        this.alert.classList.add('alert-success')
        this.alert.removeAttribute('hidden')
      } else {
        this.alert.innerHTML = `
          <p class="mb-0">
            ${this.dataset.textNoResultsFound}
          </p>
        `
        this.alert.classList.remove('alert-danger', 'alert-success')
        this.alert.classList.add('alert-warning')
        this.alert.removeAttribute('hidden')
      }
    } else {
      const data = await firstRes.json()
      console.log(data)

      let list = ''

      for (const [key, value] of Object.entries(data)) {
        list += `
          <li>
            <b>${key}</b>: ${value.toString()}
          </li>
        `
      }

      this.alert.innerHTML = `
        <ul class="ps-5 mb-0">
          ${list}
        </ul>
      `
      this.alert.classList.remove('alert-success', 'alert-warning')
      this.alert.classList.add('alert-danger')
      this.alert.removeAttribute('hidden')
    }
    this.btn.classList.remove('loading')
  }
}
customElements.define('cart-shipping-calculator', CartShippingCalculator)

